import React from 'react';
import {twMerge} from 'tailwind-merge';
import {FormProvider} from './context';

export function Form({children, className, form, schema, id, ...props}) {
	return (
		<FormProvider form={form} schema={schema}>
			<form id={id} className={twMerge('flex flex-col gap-4', className)} {...props}>
				{children}
			</form>
		</FormProvider>
	);
}

export default Form;

export function FormBlock({children, className, ...props}) {
	return (
		<div className={twMerge('flex flex-col gap-1.5', className)} {...props}>
			{children}
		</div>
	);
}

export {default as FormField} from './Field';
